import { createRouter, createWebHashHistory } from 'vue-router'

export const routes = [
  {
    path: "/login",
    name: 'login',
    meta: { notoken: true },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/',
    title: 'navbar',
    component: () => import('@/components/navbar.vue'),
    children: [
      {
        path: '/users',
        name: '/users',
        component: () => import('@/views/user/list.vue'),
        meta: { titL: ['用户管理'], tab: '/users'},
      },
      {
        path: '/userInfo/:id',
        name: '/userInfo',
        component: () => import('@/views/user/info.vue'),
        meta: { titL: ['用户管理','用户详情'], tab: '/users'},
      },
      {
        path: '/guideL',
        name: '/guideL',
        component: () => import('@/views/guide/list.vue'),
        meta: { titL: ['指南列表'], tab: '/guideL' },
      },
      {
        path: '/guideAdd/:id',
        name: '/guideAdd',
        component: () => import('@/views/guide/add.vue'),
        meta: { titL: ['指南列表','添加指南'], tab: '/guideL' },
      },
      {
        path: '/informationL',
        name: '/informationL',
        component: () => import('@/views/information/list.vue'),
        meta: { titL: ['资讯列表'], tab: '/informationL' },
      },
      {
        path: '/informationAdd/:id',
        name: '/informationAdd',
        component: () => import('@/views/information/add.vue'),
        meta: { titL: ['指南列表','添加指南'], tab: '/informationL' },
      },
      {
        path: '/knowledgeC',
        name: '/knowledgeC',
        component: () => import('@/views/knowledge/classification.vue'),
        meta: { titL: ['知识分类 '], tab: '/knowledgeC' },
      },
      {
        path: '/knowledgeL',
        name: '/knowledgeL',
        component: () => import('@/views/knowledge/list.vue'),
        meta: { titL: ['知识列表 '], tab: '/knowledgeL' },
      },
      {
        path: '/knowledgeAdd/:id',
        name: '/knowledgeAdd',
        component: () => import('@/views/knowledge/add.vue'),
        meta: { titL: ['知识列表','添加知识'], tab: '/knowledgeL' },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/navbar.vue'),
    children: [{
        path: '/bloodSugar',
        name: 'bloodSugar',
        component: () => import('@/views/warning/bloodSugar.vue'),
        meta: {
          titL: ['血糖预警'],
          tab: '/bloodSugar',
          keepAlive: true
        },
      },
      {
        path: '/bloodPressure',
        name: 'bloodPressure',
        component: () => import('@/views/warning/bloodPressure.vue'),
        meta: {
          titL: ['血压预警'],
          tab: '/bloodPressure',
          keepAlive: true
        },
      },
      // {
      //   path: '/financeInfo/:id',
      //   name: 'financeInfo',
      //   component: () => import('@/views/finance/financeInfo.vue'),
      //   meta: {
      //     titL: ['财务详情'],
      //     tab: '/finance',
      //   },
      // },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/navbar.vue'),
    children: [{
        path: '/orderReport',
        name: 'orderReport',
        component: () => import('@/views/orderReport/orderReport.vue'),
        meta: {
          titL: ['订单报告'],
          tab: '/orderReport',
        },
      },
      {
        path: '/orderReportInfo/:id',
        name: 'orderReportInfo',
        component: () => import('@/views/orderReport/orderReportInfo.vue'),
        meta: {
          titL: ['订单详情'],
          tab: '/orderReport',
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/navbar.vue'),
    children: [{
        path: '/channel',
        name: 'channel',
        component: () => import('@/views/channel/channel.vue'),
        meta: {
          titL: ['渠道商列表'],
          tab: '/channel'
        },
      },
      {
        path: '/channelInfo/:id',
        name: 'channelInfo',
        component: () => import('@/views/channel/channelInfo.vue'),
        meta: {
          titL: ['渠道商详情'],
          tab: '/channel'
        },
      },
      {
        path: '/deviceOrder',
        name: 'deviceOrder',
        component: () => import('@/views/channel/deviceOrder.vue'),
        meta: {
          titL: ['设备订单'],
          tab: '/deviceOrder',
        },
      },
      {
        path: '/deviceOrderInfo/:id',
        name: 'deviceOrderInfo',
        component: () => import('@/views/channel/deviceOrderInfo.vue'),
        meta: {
          titL: ['设备订单详情'],
          tab: '/deviceOrder'
        },
      },
      {
        path: '/device',
        name: 'device',
        component: () => import('@/views/device/device.vue'),
        meta: {
          titL: ['设备列表'],
          tab: '/device',
        },
      },
      {
        path: '/deviceInfo/:id',
        name: 'deviceInfo',
        component: () => import('@/views/device/deviceInfo.vue'),
        meta: {
          titL: ['设备详情'],
          tab: '/device',
        },
      },
      {
        path: '/onlineCard',
        name: 'onlineCard',
        component: () => import('@/views/onlineCard/onlineCard.vue'),
        meta: {
          titL: ['线上测量卡'],
          tab: '/onlineCard',
        },
      },
      {
        path: '/onlineCardInfo/:id',
        name: 'onlineCardInfo',
        component: () => import('@/views/onlineCard/onlineCardInfo.vue'),
        meta: {
          titL: ['线上测量卡','测量卡详情'],
          tab: '/onlineCard',
        },
      },
      {
        path: '/offlineCard',
        name: 'offlineCard',
        component: () => import('@/views/offlineCard/offlineCard.vue'),
        meta: {
          titL: ['线下测量卡'],
          tab: '/offlineCard',
        },
      },
      {
        path: '/offlineCardInfo/:id',
        name: 'offlineCardInfo',
        component: () => import('@/views/offlineCard/offlineCardInfo.vue'),
        meta: {
          titL: ['线下测量卡','测量卡详情'],
          tab: '/offlineCard',
        },
      },
      {
        path: '/offlineCardAdd',
        name: 'offlineCardAdd',
        component: () => import('@/views/offlineCard/offlineCardAdd.vue'),
        meta: {
          titL: ['线下测量卡','添加线下测量卡'],
          tab: '/offlineCard',
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/navbar.vue'),
    children: [{
        path: '/finance',
        name: 'finance',
        component: () => import('@/views/finance/finance.vue'),
        meta: {
          titL: ['财务明细'],
          tab: '/finance',
          keepAlive: true
        },
      },
      {
        path: '/financeInfo/:id',
        name: 'financeInfo',
        component: () => import('@/views/finance/financeInfo.vue'),
        meta: {
          titL: ['财务详情'],
          tab: '/finance',
        },
      },
    ],
  },
  {
    path: '/',
    title: '消息',
    component: () => import('@/components/navbar.vue'),
    children: [
      {
        path: '/systemNews',
        name: 'systemNews',
        component: () => import('@/views/news/systemNews.vue'),
        meta: { titL: ['系统消息'], tab: '/systemNews' },
      },
      {
        path: '/issue',
        name: 'issue',
        component: () => import('@/views/news/issue.vue'),
        meta: { titL: ['发布消息'], tab: '/systemNews' },
      },
    ],
  },
  {
    path: '/',
    title: '设置',
    component: () => import('@/components/navbar.vue'),
    children: [{
        path: '/adminInfo',
        name: 'adminInfo',
        component: () => import('@/views/set/adminInfo.vue'),
        meta: {
          titL: ['账号中心']
        },
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/set/aboutUs.vue'),
        meta: {
          titL: ['关于我们'],
          tab: '/aboutUs'
        },
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/set/feedbacklist.vue'),
        meta: {
          titL: ['反馈管理'],
          tab: '/feedback'
        },
      },
      {
        path: '/identity',
        name: 'identity',
        component: () => import('@/views/set/identity.vue'),
        meta: {
          titL: ['角色管理'],
          tab: '/identity',
          keepAlive: true
        },
      },
      {
        path: '/manager',
        name: 'manager',
        component: () => import('@/views/set/manager.vue'),
        meta: {
          titL: ['员工管理'],
          tab: '/manager',
          keepAlive: true
        },
      },
      {
        path: '/menuManage',
        name: 'menuManage',
        component: () => import('@/views/set/menuManage.vue'),
        meta: {
          titL: ['菜单管理'],
          tab: '/menuManage',
          keepAlive: true
        },
      },
      {
        path: '/advertisement',
        name: 'advertisement',
        component: () => import('@/views/set/advertisement.vue'),
        meta: {
          titL: ['广告设置'],
          tab: '/advertisement',
          keepAlive: true
        },
      },

      {
        path: '/operationLog',
        name: 'operationLog',
        component: () => import('@/views/set/operationLog.vue'),
        meta: {
          titL: ['操作日志'],
          tab: '/operationLog',
          keepAlive: true
        },
      },
      {
        path: '/article',
        name: 'article',
        component: () => import('@/views/set/article.vue'),
        meta: {
          titL: ['用户协议帮助管理'],
          tab: '/article',
        },
      },
      {
        path: '/articleEdit/:type',
        name: 'articleEdit',
        component: () => import('@/views/set/articleEdit.vue'),
        meta: {
          titL: ['编辑文章'],
          tab: '/article'
        },
      },
      {
        path: '/appVersion',
        name: 'appVersion',
        component: () => import('@/views/set/appVersion.vue'),
        meta: { titL: ['APP版本管理'], tab: '/appVersion', keepAlive: true },
      },
    ],
  },
  {
    path: '/',
    title: '河北云端',
    component: () => import('@/components/navbar.vue'),
    children: [      {
        path: '/hbMember',
        name: 'hbMember',
        component: () => import('@/views/hb/member.vue'),
        meta: {
          titL: ['河北云端', '会员列表'],
          tab: '/hbMember',
          keepAlive: true
        },
      },
      {
        path: '/hbMemberBlood',
        name: 'hbMemberBlood',
        component: () => import('@/views/hb/memberBlood.vue'),
        meta: {
          titL: ['河北云端', '会员血糖测量'],
          tab: '/hbMemberBlood',
          keepAlive: true
        },
      },
    ],
  },
  {
    path: '/',
    title: '合作商',
    component: () => import('@/components/navbar.vue'),
    children: [      {
        path: '/partnerManage',
        name: 'partnerManage',
        component: () => import('@/views/partner/partnerManage.vue'),
        meta: {
          titL: ['合作商', '合作商管理'],
          tab: '/partnerManage',
          keepAlive: true
        },
      },
      {
        path: '/partnerFirstDevice',
        name: 'partnerFirstDevice',
        component: () => import('@/views/partner/firstDeviceUserList.vue'),
        meta: {
          titL: ['合作商', '用户信息'],
          tab: '/partnerFirstDevice',
          keepAlive: true
        },
      },
      {
        path: '/partnerData',
        name: 'partnerData',
        component: () => import('@/views/partner/measureData.vue'),
        meta: {
          titL: ['合作商', '测量数据'],
          tab: '/partnerData',
          keepAlive: true
        },
      },
      {
        path: '/partnerHistory',
        name: 'partnerHistory',
        component: () => import('@/views/partner/historyData.vue'),
        meta: {
          titL: ['合作商', '历史记录'],
          tab: '/partnerData',
        },
      },
      {
        path: '/pushLog',
        name: 'pushLog',
        component: () => import('@/views/push/pushLog.vue'),
        meta: {
          titL: ['合作商', '推送日志'],
          tab: '/pushLog',
          keepAlive: true
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
